
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { CheckCircle } from "lucide-react";
import { format } from "date-fns";
import { toLocalDate } from "@/utils/dateUtils";
import { cn } from "@/lib/utils";

interface GuestFeedbackDateTimeTableProps {
  allDates: string[];  // All potential dates from the event
  selectedDates: string[] | null;  // Dates the guest has selected
  selectedTimes?: string[] | null;  // Times the guest has selected
}

export const GuestFeedbackDateTimeTable = ({ 
  allDates,
  selectedDates = [],
  selectedTimes = []
}: GuestFeedbackDateTimeTableProps) => {
  if (!allDates || allDates.length === 0) {
    return null;
  }

  // Convert selectedDates to a Set for faster lookups
  const selectedDatesSet = new Set(selectedDates || []);
  
  // Process the dates into a more useful format for display
  const processedDates = allDates.map(dateStr => {
    const formattedDate = format(toLocalDate(dateStr), 'EEE, MMM d');
    const isSelected = selectedDatesSet.has(dateStr);
    
    return {
      date: dateStr,
      formattedDate,
      isSelected,
      morning: isSelected && (selectedTimes || []).includes('morning'),
      afternoon: isSelected && (selectedTimes || []).includes('afternoon'),
      evening: isSelected && (selectedTimes || []).includes('evening')
    };
  });

  return (
    <div className="mt-2">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[120px]">Date</TableHead>
            <TableHead className="text-center">M</TableHead>
            <TableHead className="text-center">A</TableHead>
            <TableHead className="text-center">E</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {processedDates.map(dateInfo => (
            <TableRow key={dateInfo.date} className={dateInfo.isSelected ? 'bg-muted/50' : ''}>
              <TableCell className="font-medium">
                {dateInfo.formattedDate}
              </TableCell>
              <TableCell className="text-center">
                {dateInfo.morning && <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />}
              </TableCell>
              <TableCell className="text-center">
                {dateInfo.afternoon && <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />}
              </TableCell>
              <TableCell className="text-center">
                {dateInfo.evening && <CheckCircle className="w-5 h-5 text-green-500 mx-auto" />}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
